import { RequestService } from '../../../../../common/services/RequestService';
import { GET_REQUEST_BY_PROFILE } from '../constants';

export const getRequestsByProfile = payload => {
  return RequestService.get(GET_REQUEST_BY_PROFILE + payload);
};
